import { useCallback } from 'react';
import { parseAsString, useQueryState } from 'nuqs';

export interface SortOption {
  id: string;
  label: string;
  value: string;
}

const SORT_OPTIONS: SortOption[] = [
  { id: 'date-newest', label: 'Sort by Date (Newest to Oldest)', value: 'date-newest' },
  { id: 'date-oldest', label: 'Sort by Date (Oldest to Newest)', value: 'date-oldest' },
];

// todo replace with real analysis count
const ANALYSIS_COUNT = 23;

export const useContractsControls = () => {
  const [sortParam, setSortParam] = useQueryState('sort', parseAsString.withDefault('date-newest'));

  const changeSort = useCallback(
    (option: SortOption | null) => {
      if (!option) {
        return;
      }
      setSortParam(option.id);
    },
    [setSortParam],
  );

  const openContractAnalysis = useCallback(() => {
    console.log('Open contract analysis');
  }, []);

  // todo enable once contract analysis is available
  const isAnalysisDisabled = true;

  return {
    analysisCount: ANALYSIS_COUNT,
    changeSort,
    isAnalysisDisabled,
    openContractAnalysis,
    selectedSortOption: SORT_OPTIONS.find((o) => o.id === sortParam),
    sortOptions: SORT_OPTIONS,
  };
};
